/* eslint-disable no-param-reassign */
/**
 * Redux slice for the manual creator payout approval queue. Mirrors the existing
 * approvals.slice for submission payouts. State is bulk-replaced on each fetch
 * and is NOT persisted — the dashboard always fetches fresh on mount.
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ManualPayoutApproval } from 'shared/typings/approvals';

interface ManualPayoutApprovalsState {
  data: ManualPayoutApproval[];
  total: number;
}

const initialState: ManualPayoutApprovalsState = {
  data: [],
  total: 0,
};

type ManualPayoutApprovalsAction<T = ManualPayoutApprovalsState> = PayloadAction<{ data: T }>;

export const manualPayoutApprovalsSlice = createSlice({
  name: 'manualPayoutApprovals',
  initialState,
  reducers: {
    manualPayoutApprovalsLoaded: (
      state,
      action: ManualPayoutApprovalsAction<ManualPayoutApproval[]>,
    ) => {
      state.data = action.payload.data;
      state.total = action.payload.data.length;
    },
  },
});

export const { manualPayoutApprovalsLoaded } = manualPayoutApprovalsSlice.actions;

export const selectManualPayoutApprovals = (state: {
  manualPayoutApprovals: ManualPayoutApprovalsState;
}) => state.manualPayoutApprovals.data;
